/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateInventoryItemCategoryRequest } from '../models/CreateInventoryItemCategoryRequest';
import type { InventoryItemCategoryDto } from '../models/InventoryItemCategoryDto';
import type { InventoryItemCategoryProjection } from '../models/InventoryItemCategoryProjection';
import type { Page_InventoryItemCategoryDto_ } from '../models/Page_InventoryItemCategoryDto_';
import type { UpdateInventoryItemCategoryRequest } from '../models/UpdateInventoryItemCategoryRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InventoryItemCategoryControllerService {
  /**
   * getAllCategories
   * @returns Page_InventoryItemCategoryDto_ OK
   * @throws ApiError
   */
  public static getAllCategoriesUsingGet({
    limit = 10,
    offset,
    search,
  }: {
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_InventoryItemCategoryDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-item-categories',
      query: {
        limit: limit,
        offset: offset,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createCategory
   * @returns InventoryItemCategoryDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createCategoryUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreateInventoryItemCategoryRequest;
  }): CancelablePromise<InventoryItemCategoryDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/inventory-item-categories',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateCategory
   * @returns InventoryItemCategoryDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateCategoryUsingPut1({
    request,
  }: {
    /**
     * request
     */
    request: UpdateInventoryItemCategoryRequest;
  }): CancelablePromise<InventoryItemCategoryDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/inventory-item-categories',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAllCategoriesUnpaged
   * @returns InventoryItemCategoryProjection OK
   * @throws ApiError
   */
  public static getAllCategoriesUnpagedUsingGet(): CancelablePromise<
    Array<InventoryItemCategoryProjection>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/inventory-item-categories/unpaged',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteCategory
   * @returns any OK
   * @throws ApiError
   */
  public static deleteCategoryUsingDelete1({
    categoryId,
  }: {
    /**
     * categoryId
     */
    categoryId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/inventory-item-categories/{categoryId}',
      path: {
        categoryId: categoryId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
